export default (type, colors) => {
  const styles = {
    type1: {
      'user-sets__hexagon': {
        customCSS: `
          .hexagon i {
            font-size: 24px;
          }
        `
      },
      'user-sets-c-article__title': {
        minHeight: 'auto',
        marginBottom: 0
      },
      'user-sets__icon': {
        color: colors.dark
      }
    }
  }

  return styles[type]
}


// WEBPACK FOOTER //
// ./webapp/styles/dynamicStyles/userSets.js